import { unref } from 'vue';
export default async () => {
  const DEFAULT_MONTHLY_PRICE = 1299;
  const DEFAULT_ANNUAL_PRICE = 11988;
  const config = useRuntimeConfig();
  const standardAnnualPriceId = config.public.stripePriceStandardAnnual;
  const standardMonthlyPriceId = config.public.stripePriceStandardMonthly;
  const { data: prices, pending, error, refresh } = useFetch('/api/stripe/prices');
  const monthlyPrice = computed(
    () =>
      prices.value?.data?.data.find((price) => price.active && price.id == standardMonthlyPriceId) // defaults to $12.99\mo
  );
  const annualPrice = computed(
    () =>
      prices.value?.data?.data.find((price) => price.active && price.id == standardAnnualPriceId) // defaults to $120.00\yr
  )

  const getSubscriptionLabelFromBillingType = (
    membershipType: MaybeRef<'portal' | 'standard'>,
    billingType: MaybeRef<'monthly' | 'annual'>,
    seasons?: 1 | 2 | 3,
    sports?: Sport[],
    existingSports?: Sport[]
  ): {
    beginningText: string;
    fullPrice: string;
    discountedPrice: string;
    extraText: string;
  } => {
    const type = unref(billingType);
    const { prices, savings } = usePortalPassPricing(
      toRef(sports),
      existingSports ? toRef(existingSports) : undefined
    );

    if (toValue(membershipType) == 'portal') {
      const extraText =
        seasons == 1
          ? '(expires Jan 31, 2026)'
          : seasons == 2
            ? '(expires Jan 31, 2027)'
            : '(expires Jan 31, 2028)';

      let fullPrice: number;
      let discountedPrice: number;

      switch (seasons) {
        case 1:
        default:
          fullPrice = prices.value.single;
          discountedPrice = prices.value.single;
          break;
        case 2:
          fullPrice = prices.value.fullDouble;
          discountedPrice = prices.value.double;
          break;
        case 3:
          fullPrice = prices.value.fullTriple;
          discountedPrice = prices.value.triple;
          break;
      }
      return {
        beginningText: 'Due today:',
        fullPrice: `${fullPrice}.00`,
        discountedPrice: `${discountedPrice}.00`,
        extraText,
      };
    }

    return {
      beginningText: '',
      fullPrice:
        type == 'monthly'
          ? ((monthlyPrice?.value?.unit_amount || DEFAULT_MONTHLY_PRICE) / 100).toFixed(2)
          : ((annualPrice?.value?.unit_amount || DEFAULT_ANNUAL_PRICE) / 12 / 100).toFixed(2),
      discountedPrice: '',
      extraText: type == 'monthly' ? '/mo. billed monthly' : '/mo. billed annually',
    };
  };

  return {
    DEFAULT_ANNUAL_PRICE,
    DEFAULT_MONTHLY_PRICE,
    prices,
    pending,
    refresh,
    error,
    monthlyPrice,
    annualPrice,
    getSubscriptionLabelFromBillingType,
  };
};
